import DefaultMortgageHeader from './DefaultMortgageHeader';
import ExpiredPolicyView from './ExpiredPolicyView';
import HelocDrawer from './HelocDrawHeader';

export default {
  default: DefaultMortgageHeader,
  expired: ExpiredPolicyView,
  heloc: HelocDrawer,
};
